import { makeRequest } from 'utils/requestLogger';

export default (submissionID, historyID) =>
  makeRequest('get', `/api/submissions/${submissionID}/history/${historyID}`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/getSubmissionHistory.js